import { render } from "./snackbar.vue?vue&type=template&id=67cd8405"
import script from "./snackbar.vue?vue&type=script&lang=js"
export * from "./snackbar.vue?vue&type=script&lang=js"

import exportComponent from "/Users/basil/Documents/rishad/ncp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__